export const COLORS_MAP = {
  white: 'offer--white',
  yellow: 'offer--yellow',
  blue: 'offer--blue',
};

export const MAIN_LOCATOR = 'OfferCard';
export const TARGET_BLANK_SLUG = '_blank';
export const TARGET_SELF_SLUG = '_self';

export const DEFAULT_COLOR = 'white';
export const DARK_COLORS = ['blue'];

export const CARD_ACTIONS = {
  COPY_DATA: 'copydata',
  FETCH_DATA: 'fetchdata',
  NO_ACTION: 'noaction',
  LINK: 'link',
};

export const OFFERS_TYPES = {
  direct_discount: 'direct_discount',
  common_discount: 'common_discount',
  personal_promo: 'personal_promo',
  common_promo: 'common_promo',
  referral_promo: 'referral_promo',
  referral_link: 'referral_link',
  dynamic_link: 'dynamic_link',
  info: 'info',
};

export const OFFERS_SOURCE = {
  LOCAL: 'local',
  REMOTE: 'remote',
};

export const PERMISSION_NAMES = {
  GUEST: 'Guest',
  USER: 'User',
  NEVER: 'Never',
};
